import React, { useState } from 'react';
import {
    Box,
    TextField,
    Typography,
    Button,
    CircularProgress,
    MenuItem
} from '@mui/material';

export const CibilDetails = () => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        address: '',
        dob: '',
        email: '',
        first_name: '',
        gender: '',
        last_name: '',
        pan_card_number: '',
        phone_number: '',
        pin_code: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleAdd = async (e) => {
        e.preventDefault();
        setLoading(true);
        // Handle form submission here.
        setLoading(false);
    };

    const handleClear = () => {
        setFormData({
            address: '',
            dob: '',
            email: '',
            first_name: '',
            gender: '',
            last_name: '',
            pan_card_number: '',
            phone_number: '',
            pin_code: ''
        });
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="flex-start"
            height="100vh"
            paddingTop="20px"
        >
            <Box
                width="100%"
                maxWidth="500px"
                padding="20px"
                backgroundColor="#fff"
                borderRadius="8px"
                boxShadow="0 4px 8px rgba(0, 0, 0, 0.2)"
                border="1px solid rgba(0, 0, 0, 0.1)"
                paddingBottom="40px"
            >
                <Typography
                    variant="h5"
                    gutterBottom
                    align="center"
                    sx={{
                        fontWeight: 'bold',
                        textShadow: '1px 1px 2px rgba(0, 0, 0, 0.2)',
                        color: '#333'
                    }}
                >
                    ADD DETAILS
                </Typography>
                <form onSubmit={handleAdd}>
                    <TextField
                        label="Address"
                        name="address"
                        value={formData.address}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        required
                    />
                    <TextField
                        label="Date of Birth"
                        name="dob"
                        type="date"
                        value={formData.dob}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true
                        }}
                        required
                    />
                    <TextField
                        label="Email ID"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        required
                    />
                    <TextField
                        label="First Name"
                        name="first_name"
                        value={formData.first_name}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        required
                    />
                    <TextField
                        label="Gender"
                        name="gender"
                        value={formData.gender}
                        onChange={handleInputChange}
                        select
                        fullWidth
                        margin="normal"
                        required
                    >
                        <MenuItem value="male">Male</MenuItem>
                        <MenuItem value="female">Female</MenuItem>
                        <MenuItem value="other">Other</MenuItem>
                    </TextField>
                    <TextField
                        label="Last Name"
                        name="last_name"
                        value={formData.last_name}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        required
                    />
                    <TextField
                        label="PAN Card Number"
                        name="pan_card_number"
                        value={formData.pan_card_number}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        required
                    />
                    <TextField
                        label="Phone Number"
                        name="phone_number"
                        value={formData.phone_number}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        required
                    />
                    <TextField
                        label="Pin Code"
                        name="pin_code"
                        value={formData.pin_code}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        required
                    />
                    <Box display="flex" justifyContent="space-between" mt={2}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleClear}
                            style={{ flexGrow: 1, marginRight: 8 }}
                        >
                            Clear
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            style={{ flexGrow: 1 }}
                        >
                            {loading ? <CircularProgress size={24} /> : 'Add'}
                        </Button>
                    </Box>
                </form>
            </Box>
        </Box>
    );
};
